import * as type from '../../../actions/index.types'

const initialState = {
    // List
    notesData: [],
    notesPagination: null,
    loading: false,
    error: null,

    // Details
    noteDetails: null,
    detailsLoading: false,
    detailsError: null,

    // Notes by Invoice
    notesByInvoice: [],
    notesByInvoiceLoading: false,
    notesByInvoiceError: null,

    // Create
    createLoading: false,
    createError: null,

    // Update
    updateLoading: false,
    updateError: null,

    // Post
    postLoading: false,
    postError: null,

    // Void
    voidLoading: false,
    voidError: null,

    // Delete
    deleteLoading: false,
    deleteError: null,

    // Bulk Upload
    bulkUploadLoading: false,
    bulkUploadResult: null,
    bulkUploadError: null,

    // Bulk Get Details
    bulkDetailsLoading: false,
    bulkDetailsData: [],
    bulkDetailsError: null,

    // Bulk Post
    bulkPostLoading: false,
    bulkPostResult: null,
    bulkPostError: null,

    // Bulk Delete
    bulkDeleteLoading: false,
    bulkDeleteResult: null,
    bulkDeleteError: null,
}

export function CreditDebitNoteReducer(state = initialState, action) {
    switch (action.type) {
        // Get Notes
        case type.GET_CREDIT_DEBIT_NOTES:
            return { ...state, loading: true, error: null }
        case type.GET_CREDIT_DEBIT_NOTES_SUCCESS:
            return {
                ...state,
                loading: false,
                notesData: action.payload?.data || [],
                notesPagination: action.payload?.meta?.pagination || null,
                error: null
            }
        case type.GET_CREDIT_DEBIT_NOTES_FAILURE:
            return { ...state, loading: false, error: action?.message || 'Failed to fetch notes' }

        // Get Note Details
        case type.GET_CREDIT_DEBIT_NOTE_DETAILS:
            return { ...state, detailsLoading: true, detailsError: null }
        case type.GET_CREDIT_DEBIT_NOTE_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                noteDetails: action.payload?.data || null,
                detailsError: null
            }
        case type.GET_CREDIT_DEBIT_NOTE_DETAILS_FAILURE:
            return { ...state, detailsLoading: false, detailsError: action?.message || 'Failed to fetch note details' }

        // Get Notes by Invoice
        case type.GET_CREDIT_DEBIT_NOTES_BY_INVOICE:
            return { ...state, notesByInvoiceLoading: true, notesByInvoiceError: null }
        case type.GET_CREDIT_DEBIT_NOTES_BY_INVOICE_SUCCESS:
            return {
                ...state,
                notesByInvoiceLoading: false,
                notesByInvoice: action.payload?.data || [],
                notesByInvoiceError: null
            }
        case type.GET_CREDIT_DEBIT_NOTES_BY_INVOICE_FAILURE:
            return { ...state, notesByInvoiceLoading: false, notesByInvoiceError: action?.message || 'Failed to fetch notes by invoice' }

        // Create
        case type.CREATE_CREDIT_DEBIT_NOTE:
            return { ...state, createLoading: true, createError: null }
        case type.CREATE_CREDIT_DEBIT_NOTE_SUCCESS:
            return { ...state, createLoading: false, createError: null }
        case type.CREATE_CREDIT_DEBIT_NOTE_FAILURE:
            return { ...state, createLoading: false, createError: action?.message || 'Failed to create note' }

        // Update
        case type.UPDATE_CREDIT_DEBIT_NOTE:
            return { ...state, updateLoading: true, updateError: null }
        case type.UPDATE_CREDIT_DEBIT_NOTE_SUCCESS:
            return { ...state, updateLoading: false, updateError: null }
        case type.UPDATE_CREDIT_DEBIT_NOTE_FAILURE:
            return { ...state, updateLoading: false, updateError: action?.message || 'Failed to update note' }

        // Post
        case type.POST_CREDIT_DEBIT_NOTE:
            return { ...state, postLoading: true, postError: null }
        case type.POST_CREDIT_DEBIT_NOTE_SUCCESS:
            return { ...state, postLoading: false, postError: null }
        case type.POST_CREDIT_DEBIT_NOTE_FAILURE:
            return { ...state, postLoading: false, postError: action?.message || 'Failed to post note' }

        // Void
        case type.VOID_CREDIT_DEBIT_NOTE:
            return { ...state, voidLoading: true, voidError: null }
        case type.VOID_CREDIT_DEBIT_NOTE_SUCCESS:
            return { ...state, voidLoading: false, voidError: null }
        case type.VOID_CREDIT_DEBIT_NOTE_FAILURE:
            return { ...state, voidLoading: false, voidError: action?.message || 'Failed to void note' }

        // Delete
        case type.DELETE_CREDIT_DEBIT_NOTE:
            return { ...state, deleteLoading: true, deleteError: null }
        case type.DELETE_CREDIT_DEBIT_NOTE_SUCCESS:
            return { ...state, deleteLoading: false, deleteError: null }
        case type.DELETE_CREDIT_DEBIT_NOTE_FAILURE:
            return { ...state, deleteLoading: false, deleteError: action?.message || 'Failed to delete note' }

        // Bulk Upload
        case type.BULK_UPLOAD_CREDIT_DEBIT_NOTES:
            return { ...state, bulkUploadLoading: true, bulkUploadResult: null, bulkUploadError: null }
        case type.BULK_UPLOAD_CREDIT_DEBIT_NOTES_SUCCESS:
            return { ...state, bulkUploadLoading: false, bulkUploadResult: action.payload, bulkUploadError: null }
        case type.BULK_UPLOAD_CREDIT_DEBIT_NOTES_FAILURE:
            return { ...state, bulkUploadLoading: false, bulkUploadError: action?.message || 'Bulk upload failed' }

        // Clear Bulk Upload State
        case type.CLEAR_CREDIT_DEBIT_NOTE_BULK_UPLOAD_STATE:
            return { ...state, bulkUploadLoading: false, bulkUploadResult: null, bulkUploadError: null }

        // Bulk Get Details
        case type.BULK_GET_CREDIT_DEBIT_NOTE_DETAILS:
            return { ...state, bulkDetailsLoading: true, bulkDetailsError: null }
        case type.BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_SUCCESS:
            return { ...state, bulkDetailsLoading: false, bulkDetailsData: action.payload?.data || [], bulkDetailsError: null }
        case type.BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_FAILURE:
            return { ...state, bulkDetailsLoading: false, bulkDetailsError: action?.message || 'Failed to fetch bulk note details' }

        // Bulk Post
        case type.BULK_POST_CREDIT_DEBIT_NOTES:
            return { ...state, bulkPostLoading: true, bulkPostResult: null, bulkPostError: null }
        case type.BULK_POST_CREDIT_DEBIT_NOTES_SUCCESS:
            return { ...state, bulkPostLoading: false, bulkPostResult: action.payload, bulkPostError: null }
        case type.BULK_POST_CREDIT_DEBIT_NOTES_FAILURE:
            return { ...state, bulkPostLoading: false, bulkPostError: action?.message || 'Bulk post failed' }

        // Bulk Delete
        case type.BULK_DELETE_CREDIT_DEBIT_NOTES:
            return { ...state, bulkDeleteLoading: true, bulkDeleteResult: null, bulkDeleteError: null }
        case type.BULK_DELETE_CREDIT_DEBIT_NOTES_SUCCESS:
            return { ...state, bulkDeleteLoading: false, bulkDeleteResult: action.payload, bulkDeleteError: null }
        case type.BULK_DELETE_CREDIT_DEBIT_NOTES_FAILURE:
            return { ...state, bulkDeleteLoading: false, bulkDeleteError: action?.message || 'Bulk delete failed' }

        // Clear State
        case type.CLEAR_CREDIT_DEBIT_NOTE_STATE:
            return initialState

        default:
            return state
    }
}
